import { ModifyIdentity } from '@grid/models';
import { DprConsumableDetail } from '@shared/models/dpr';

export interface DprConsumableDetailGridData
  extends ModifyIdentity<DprConsumableDetail> {
  name: string;
  priority: number;
  total: number;
  dailyStockDetailsTotalStartOfDay?: number;
  dailyStockDetailsTotalEndOfDay?: number;
  dailyStockDetailsTotalUsed?: number;
}
